import { render } from "./ProspectConversationRow.vue?vue&type=template&id=aefb4d5a&scoped=true&ts=true"
import script from "./ProspectConversationRow.vue?vue&type=script&lang=ts"
export * from "./ProspectConversationRow.vue?vue&type=script&lang=ts"

import "./ProspectConversationRow.vue?vue&type=style&index=0&id=aefb4d5a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aefb4d5a"]])

export default __exports__